var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
export var downloadPDF = function (_a) {
    var props = __rest(_a, []);
    return (_jsx("svg", __assign({ width: "18", height: "19", viewBox: "0 0 18 19", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 1C10 0.447715 9.55228 0 9 0C8.44771 0 8 0.447715 8 1V11.2629L3.05162 7.1107C2.62855 6.7557 1.99779 6.81088 1.64279 7.23396C1.28779 7.65703 1.34297 8.28779 1.76604 8.64279L8.37403 14.1875C8.57627 14.3572 8.82597 14.4332 9.07031 14.4201C9.31466 14.4332 9.56435 14.3572 9.76659 14.1875L16.3746 8.64279C16.7977 8.28779 16.8528 7.65703 16.4978 7.23396C16.1428 6.81088 15.5121 6.7557 15.089 7.1107L10 11.3809V1ZM2 12.002C2 11.4497 1.55228 11.002 1 11.002C0.447715 11.002 0 11.4497 0 12.002V17.002C0 17.5542 0.447715 18.002 1 18.002H17C17.5523 18.002 18 17.5542 18 17.002V12.002C18 11.4497 17.5523 11.002 17 11.002C16.4477 11.002 16 11.4497 16 12.002V16.002H2V12.002Z", fill: "#068464" }) })));
};
